import React from 'react';

import Icon from '../../../components/AppIcon';

const ServiceTable = ({ services, countries, onEdit, onDelete, onManageAvailability, onToggleStatus, language }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Service
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Code
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Catégorie
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Prix Unitaire
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Pays Disponibles
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Statut
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {services?.map((service) => (
              <tr key={service?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-6 py-4">
                  <div>
                    <p className="font-medium text-foreground">{service?.serviceName}</p>
                    <p className="text-sm text-muted-foreground line-clamp-1">{service?.description}</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm font-mono text-foreground">{service?.serviceCode}</span>
                </td>
                <td className="px-6 py-4">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
                    {service?.category}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm font-semibold text-foreground">
                    {parseFloat(service?.unitPrice || 0)?.toFixed(2)} 
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-foreground font-medium">
                      {service?.availableCountries?.filter(c => c?.isAvailable)?.length || 0}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      / {countries?.length || 0} pays
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => onToggleStatus(service?.id, service?.isActive)}
                    className="flex items-center gap-2"
                  >
                    {service?.isActive ? (
                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-500/10 text-green-500 flex items-center gap-1">
                        <Icon name="CheckCircle" size={14} />
                        Actif
                      </span>
                    ) : (
                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-500/10 text-gray-500 flex items-center gap-1">
                        <Icon name="XCircle" size={14} />
                        Inactif
                      </span>
                    )}
                  </button>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center justify-end gap-2">
                    <button
                      onClick={() => onManageAvailability(service)}
                      className="p-2 rounded-lg hover:bg-muted transition-colors"
                      title="Gérer la disponibilité"
                    >
                      <Icon name="Globe" size={18} className="text-muted-foreground" />
                    </button>
                    <button
                      onClick={() => onEdit(service)}
                      className="p-2 rounded-lg hover:bg-muted transition-colors"
                      title="Modifier"
                    >
                      <Icon name="Edit" size={18} className="text-muted-foreground" />
                    </button>
                    <button
                      onClick={() => onDelete(service?.id)}
                      className="p-2 rounded-lg hover:bg-destructive/10 transition-colors"
                      title="Supprimer"
                    >
                      <Icon name="Trash2" size={18} className="text-destructive" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceTable;